module.exports = __webpack_public_path__ + "img/Will.d7dcddb3.jpg";